import { render, staticRenderFns } from "./HeroSmall.vue?vue&type=template&id=2544045a&scoped=true&"
import script from "./HeroSmall.vue?vue&type=script&lang=js&"
export * from "./HeroSmall.vue?vue&type=script&lang=js&"
import style0 from "./HeroSmall.vue?vue&type=style&index=0&id=2544045a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2544045a",
  null
  
)

export default component.exports